// extracted by mini-css-extract-plugin
export default {"section":"Footer_section__nZdLk","anchor":"Footer_anchor__dLUSj"};